// src/App.js
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Flowbite } from "flowbite-react";
import CreateAWill from "pages/CreateAWill";
import Blogs from "pages/footerPages/Blogs";
import ContactUs from "pages/footerPages/ContactUs";
import FAQs from "pages/footerPages/FAQs";
import PrivacyPolicy from "pages/footerPages/PrivacyPolicy";
import TermsAndConditions from "pages/footerPages/TermsAndConditions";
// responsive pages
import Navigation from "components/Navigation";
import SiteFooter from "components/SiteFooter";
import Home from "./pages/home/Home";
import Partners from "./pages/Partners";
import Layout from "./Layout";

const App = () => (
	<Flowbite>
		<Router>
			<Navigation />
			<Layout>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/create-a-will" element={<CreateAWill />} />
					<Route path="/partners" element={<Partners />} />
					<Route path="/blogs-and-news" element={<Blogs />} />
					<Route path="/faqs" element={<FAQs />} />
					<Route path="/contact-us" element={<ContactUs />} />
					<Route
						path="/terms-and-conditions"
						element={<TermsAndConditions />}
					/>
					<Route path="/privacy-policy" element={<PrivacyPolicy />} />
					<Route path="/partners" element={<Partners />} />
				</Routes>
				<SiteFooter />
			</Layout>
		</Router>
	</Flowbite>
);

export default App;
